import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppVersion } from 'hooks';
import { UiIcon, UiTooltip } from 'ui-components';
import { StyledProfileMenuVersion } from './ProfileMenuVersion.styles';

const ProfileMenuVersion = ({ close }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const version = useAppVersion();
  const isMobile = window.innerWidth <= 600;

  if (!version?.number) return null;

  const handleNavigateToChangelog = () => {
    close?.();
    navigate('/changelog');
  };

  return (
    <StyledProfileMenuVersion className='profile-menu-version'>
      <div className='version-number' onClick={handleNavigateToChangelog}>
        {isMobile && <UiIcon icon='ri-history-line' size={16} />}

        {t('changelog:version', {
          versionNumber: version.number,
        })}
      </div>
      {isMobile && (
        <span
          className='version-history-link'
          onClick={handleNavigateToChangelog}
        >
          {t('changelog:versionHistory')}
        </span>
      )}
      {!isMobile && (
        <UiTooltip title={t('changelog:versionHistory')} placement='top'>
          <span
            className='version-history-link'
            onClick={handleNavigateToChangelog}
            data-testid='profile-menu-changelog-link'
          >
            <UiIcon icon='ri-history-line' size={16} />
          </span>
        </UiTooltip>
      )}
    </StyledProfileMenuVersion>
  );
};

ProfileMenuVersion.propTypes = {
  close: PropTypes.func,
};

export default ProfileMenuVersion;
